import React, {Component} from 'react';
import './Product.css';
import Logo from "../../Elements/Logo/Logo";

class Product extends Component {
    constructor(props) {
        super(props);

        this.state = {
            product: this.props.product
        };

        this.openDetail = this.openDetail.bind(this);
    }

    openDetail(e) {
        this.setState({
           product: this.props.product
        });
        this.props.setProduct(this.props.product);
        this.props.changeRoute('product');
    }

    render() {
        return <div className="ProductResult product-teaser no-select" onClick={(event) => this.openDetail(event)}>
                <div className="product-teaser--inner">
                    <div className="product-teaser--overlay">
                        <div className="product-teaser--title">
                            {this.props.product.title}
                        </div>
                    </div>
                </div>
            </div>
    }
}

export default Product;


// WEBPACK FOOTER //
// ./src/Components/Listview/Product/Product.js